module.exports = "https://cdn.thelire.com/ins/resource/buy1get1.7834e17176ae3382f4de03e42b8f88df.jpg";